<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'tabs',
  computed: {
    index: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
    // gridStyle() {
    //   const count = this.tabs.length * 2 + 1;
    //   return `grid-template-columns: repeat(${count},min-content) 1fr;`;
    // },
  },
  emits: ['update:modelValue'],
  props: ['tabs', 'modelValue'],
});
</script>

<template>
<!--  <div class="grid p-4" :style="gridStyle">-->
<!--    <template v-for="(tab, i) in tabs">-->
<!--      <div-->
<!--        class="w-[20px]"-->
<!--        :style="i === index ? 'transform: rotateY(180deg)' : ''"-->
<!--        v-if="i === index || i === index + 1"-->
<!--      >-->
<!--        <svg viewBox="0 0 20 30" preserveAspectRatio="none" class="w-full h-full">-->
<!--          <path-->
<!--            d="M -1 1 L 2 1 C 15 3, 5 27, 17 29 L 21 29"-->
<!--            stroke="rgb(107 114 128 / var(&#45;&#45;tw-border-opacity, 1))"-->
<!--            fill="transparent"-->
<!--            stroke-width="2"-->
<!--            vector-effect="non-scaling-stroke"-->
<!--          />-->
<!--        </svg>-->
<!--      </div>-->
<!--      <div class="w-[20px] h-[30px] border-y-2 border-t-transparent border-b-gray-500" v-else />-->
<!--      <div-->
<!--        :class="{-->
<!--          'px-2 pb-1 h-[30px] border-y-2 border-transparent': true,-->
<!--          'border-t-gray-500 text-white': i === index,-->
<!--          'border-b-gray-500 text-gray-500': i !== index,-->
<!--        }"-->
<!--      >-->
<!--        {{ tab.name }}-->
<!--      </div>-->
<!--    </template>-->
<!--    <div class="w-[20px]" v-if="index === tabs.length - 1">-->
<!--      <svg viewBox="0 0 20 30" preserveAspectRatio="none" class="w-full h-full">-->
<!--        <path-->
<!--          d="M -1 1 L 2 1 C 15 3, 5 27, 17 29 L 21 29"-->
<!--          stroke="rgb(107 114 128 / var(&#45;&#45;tw-border-opacity, 1))"-->
<!--          fill="transparent"-->
<!--          stroke-width="2"-->
<!--          vector-effect="non-scaling-stroke"-->
<!--        />-->
<!--      </svg>-->
<!--    </div>-->
<!--    <div class="w-[20px] h-[30px] border-y-2 border-t-transparent border-b-gray-500" v-else />-->
<!--    <div class="border-y-2 border-t-transparent border-b-gray-500 h-[30px]"></div>-->
<!--  </div>-->

  <div class="px-4">
    <div class="flex gap-1 my-4">
      <template v-for="(tab, i) in tabs" :id="`tab-${tab.id}`">
        <div
          :class="{
            'px-2 py-1 text-gray-500 border-gray-500 border-b-2 animate-normal transition-colors': true,
            'cursor-pointer': i !== index,
            'text-yellow-600 border-yellow-500 dark:text-yellow-500 dark:border-yellow-500':
              i === index,
            'hover:text-black hover:dark:text-white hover:border-black hover:dark:border-white':
              i !== index,
          }"
          @click="index = i"
        >
          {{ tab.name }}
          <template v-if="tab.params.length"> [{{ tab.params.join(':') }}]</template>
        </div>
      </template>
    </div>
    <template v-for="(tab, i) in tabs" :id="`tab-${tab.id}`">
      <slot v-if="index === i" :name="tab.id" />
    </template>
  </div>
</template>

<style scoped lang="scss"></style>
